import { BMP_CostDeduction } from "../models/bmp.model";
import { responseHero } from "../utils/axiosInterceptor";

export const getBMPCostDeduction = (): Promise<BMP_CostDeduction[]> => {
    return new Promise<BMP_CostDeduction[]>((resolve, reject) => {
        responseHero.get(`${process.env.REACT_APP_API_URL}/bmp/costs`).then((response) => {
            resolve(response.data as BMP_CostDeduction[]);
        })
        .catch(error => {
            console.error(error);
            reject(error);
        });
    });
};